module.exports = __webpack_public_path__ + "static/media/Export-blue.4c9c8b38.svg";